export const FETCH_CREDIT_TO_EXPIRE = 'FETCH_CREDIT_TO_EXPIRE';
export const FETCH_CREDIT_TO_EXPIRE_SUCCESS = `${FETCH_CREDIT_TO_EXPIRE}_SUCCESS`;
export const FETCH_CREDIT_TO_EXPIRE_FAIL = `${FETCH_CREDIT_TO_EXPIRE}_FAIL`;

const CreditToExpireReducer = (state = {
  isLoading: false,
  isLoaded: false,
  error: null,
}, action = {}) => {
  switch (action.type) {
    case FETCH_CREDIT_TO_EXPIRE:
      return { ...state, isLoading: true };
    case FETCH_CREDIT_TO_EXPIRE_SUCCESS:
      return {
        ...state,
        items: action.payload.data,
        isLoading: false,
        isLoaded: true,
      };
    case FETCH_CREDIT_TO_EXPIRE_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.error,
      };
    default:
      return state;
  }
};

export default CreditToExpireReducer;
